import { ModalOffer } from "components/ModalOffer";

const CalculatorProModalModal = ({
  modalOpenType,
  onClose
}: {
  modalOpenType: string;
  onClose: () => void;
}) => {
  return (
    <ModalOffer
      modalIsOpen={Boolean(modalOpenType)}
      modalOpenType={modalOpenType}
      onCloseClick={onClose}
    />
  );
}

export default CalculatorProModalModal;